import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { compose, lifecycle } from 'recompose'

import {
  getGlobalAutoCloseConfiguration,
  isGlobalAutoCloseConfigurationLoaded,
  isGlobalAutoCloseConfigurationLoading,
} from 'app/modules/conversation/selectors'

import {
  fetchGlobalAutoCloseConfiguration
} from 'app/modules/conversation/actions'

const mapStateToProps = state => {
  const isLoaded = isGlobalAutoCloseConfigurationLoaded(state)

  return {
    globalAutoCloseConfiguration: getGlobalAutoCloseConfiguration(state),
    isGlobalAutoCloseConfigurationLoaded: isLoaded,
    doFetch: !isLoaded && !isGlobalAutoCloseConfigurationLoading(state),
  }
}

const mapDispatchToProps = dispatch => bindActionCreators(
  { fetchGlobalAutoCloseConfiguration },
  dispatch,
)

const withGlobalAutoCloseConfiguration = compose(
    connect(mapStateToProps, mapDispatchToProps),
    lifecycle({
      componentDidMount() {
        if (this.props.doFetch) {
          this.props.fetchGlobalAutoCloseConfiguration()
        }
      },
    })
  )

export default withGlobalAutoCloseConfiguration



// WEBPACK FOOTER //
// ./src/scripts/components/settings/advancedConversationSettings/AutoCloseConfiguration/withGlobalAutoCloseConfiguration.js